import React, { useState, useContext, useEffect, FunctionComponent } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useIntl } from 'react-intl';

import { FlashMessage, FlashMessageType } from '@pegasus/ui-components/legacy/FlashMessage';
import { Footer } from '@pegasus/ui-footers/components/footer';
import { Footer as FooterInterface } from '@pegasus/ui-footers/types/content';
import { FeedbackOverlay } from '@pegasus/ui-footers/components/feedback';
import { postLegacyFeedback } from '@pegasus/ui-footers/components/form/helpers';

import { getWebviewOs } from '@client/redux/modules/clientDevice/selectors';
import { fetchFooter } from '@client/redux/modules/footer/actions';
import { getFooter } from '@client/redux/modules/footer/selectors';
import { getCustomer } from '@client/redux/modules/customer/selectors';
import { showHeaderSuccessFlashMessage } from '@client/redux/modules/flashMessage/actions';
import { getToken } from '@client/redux/modules/user/selectors';

import { TranslateContext } from '@pegasus/translation/components/TranslateContext';

export const FooterWrapper: FunctionComponent<{}> = () => {
    const dispatch = useDispatch();
    const footer: FooterInterface = useSelector(getFooter);
    const customer = useSelector(getCustomer);
    const token = useSelector(getToken);
    const isWebview = !!useSelector(getWebviewOs);
    const intl = useIntl();

    if (isWebview) {
        return null;
    }

    useEffect(() => {
        dispatch(fetchFooter());
    }, []);

    const translateContext = useContext(TranslateContext);

    const [errorMessage, setErrorMessage] = useState<string | undefined>();
    const [isFeedbackOpen, setIsFeedbackOpen] = useState(false);

    return (
        <>
            {customer && (
                <FeedbackOverlay
                    isShown={isFeedbackOpen}
                    closeDialog={() => {
                        setIsFeedbackOpen(false);
                    }}
                    messages={
                        errorMessage && (
                            <FlashMessage
                                type={FlashMessageType.ERROR}
                                disableAnimation
                                onHide={() => setErrorMessage(undefined)}
                            >
                                {errorMessage}
                            </FlashMessage>
                        )
                    }
                    customer={customer}
                    onSubmit={values => {
                        return postLegacyFeedback(
                            values,
                            token
                        ).then(response => {
                            if (!response.ok) {
                                setErrorMessage(
                                    intl.formatMessage({
                                        id: 'feedbackOverlay.failedSendEmail',
                                    }),
                                );

                                return;
                            }

                            dispatch(
                                showHeaderSuccessFlashMessage(
                                    intl.formatMessage({
                                        id: 'feedbackOverlay.successResponse',
                                    })
                                )
                            );

                            setIsFeedbackOpen(false);
                        });
                    }}
                    translations={translateContext.translations}
                />
            )}
            {footer && (
                <Footer
                    footer={footer}
                    onAction={action => {
                        if (action === 'onpage-feedback') {
                            setIsFeedbackOpen(true);
                        }

                        return false;
                    }}
                />
            )}
        </>
    );
};

export default FooterWrapper;
